import React, { FC, useEffect, useRef, useState } from 'react';
import { CloseButton, CustomButton, FormInput, ValidatorFormItem } from '../../../../styles/styled';
import { linearNameRegExp } from '../../../../utils/patterns';
import { BooksType, BookType, RulerType, TextbooksValidatorType } from '../../types';
import BookForm from './components/BookForm';
import { emptyBookTemplate } from './components/BookForm/BookForm';
import { BookRegistrationContainer, CloseCollapseTag, InputCloseBlock } from './styled';

type BookRegistrationProps = {
  removeRulerById: () => void;
  updateRuler: (value: RulerType) => void;
  validated?: TextbooksValidatorType;
  id: number;
  textbooks?: BooksType;
  ruler?: RulerType;
  publisherId?: number;
};

export const BookRegistrationComponent: FC<BookRegistrationProps> = ({
  removeRulerById,
  updateRuler,
  ruler,
  validated,
  id,
  textbooks,
  publisherId,
}) => {
  const [booksState, setBooksState] = useState<BooksType>([]);
  const [linearInput, setLinearInput] = useState<string>(ruler?.title || `Линейка ${id + 1}`);
  const updateOneTime = useRef(true);

  useEffect(() => {
    const newBookState = booksState?.map((el) => {
      delete el.status;

      return el;
    });

    updateRuler(
      ruler?.id
        ? { title: linearInput, textbooks: newBookState, id: ruler.id }
        : { title: linearInput, textbooks: newBookState },
    );
    // eslint-disable-next-line
  }, [booksState, linearInput]);

  const removeBook = (id: number) => {
    const newBooksList = [...booksState];
    newBooksList.splice(id, 1);
    setBooksState(newBooksList);
  };

  const updateBookFunc = (id: number, book: BookType) => {
    const booksList = [...booksState];
    booksList[id] = book;
    setBooksState(booksList);
  };

  useEffect(() => {
    if (textbooks && updateOneTime.current) {
      updateOneTime.current = false;
      setBooksState(textbooks);
    }
  }, [textbooks, updateOneTime]);

  return (
    <BookRegistrationContainer>
      <InputCloseBlock>
        <ValidatorFormItem validator={!linearNameRegExp.test(linearInput)}>
          <FormInput
            style={{ maxWidth: '400px' }}
            value={ruler?.title || linearInput}
            onChange={(e) => setLinearInput(e.target.value)}
          />
        </ValidatorFormItem>
        <CloseCollapseTag>
          <CloseButton onClick={() => removeRulerById()}>+</CloseButton>
        </CloseCollapseTag>
      </InputCloseBlock>
      {booksState.map((el, index) => {
        return (
          <BookForm
            validated={
              validated && validated.filter((el) => el.index === index).length > 0
                ? validated.filter((el) => el.index === index)[0]
                : undefined
            }
            book={textbooks ? el : undefined}
            publisherId={publisherId}
            updateBook={(value: BookType) => updateBookFunc(index, value)}
            removeBook={() => removeBook(index)}
            key={index}
          />
        );
      })}
      <CustomButton
        onClick={() => setBooksState([...booksState, emptyBookTemplate])}
        lined
        style={{ marginLeft: '20px', maxWidth: '250px' }}
      >
        добавить учебник
      </CustomButton>
    </BookRegistrationContainer>
  );
};
